import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            throwOnError: (error) => {
                if (axios.isAxiosError(error)) {
                    const status = error.response?.status;
                    return status === 403 || status === 404;
                }
                return false;
            },
        },
    },
});
